import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {HttpClientService} from '../../services/http-client.service';
import {NewSimulationService} from "../new-simulation/new-simulation.service";

@Injectable()
export class SimulationsService {

    public loadedSimulation;
    public regions = [];
    public tableMetaData = [
        {
            key: 'username',
            title: 'User',
            enabled: true
        },
        {
            key: 'Target_payer_name',
            title: 'Tendering Entity',
            enabled: true
        },
        {
            key: 'Country_name',
            title: 'Country',
            enabled: true
        },
        {
            key: 'Simulation_Name',
            title: 'Simulation Name',
            enabled: true
        },
        {
            key: 'Simulation_type',
            title: 'Simulation type',
            enabled: false
        },
        {
            key: 'Brand_Name',
            title: 'Brand Name',
            enabled: true
        },
        {
            key: 'Active_ingredient',
            title: 'Active ingredients',
            enabled: true
        },
        {
            key: 'ATC_code',
            title: 'ATC code',
            enabled: true
        },
        {
            key: 'Strength',
            title: 'Strength',
            enabled: true
        },
        {
            key: 'Strength_unit',
            title: 'Strength Unit',
            enabled: true
        },
        {
            key: 'Form',
            title: 'Form',
            enabled: true
        },
        {
            key: 'Pack_size',
            title: 'Pack size',
            enabled: true
        },
        // {
        //     key: 'Content_size',
        //     title: 'Content size',
        //     enabled: false
        // },
        {
            key: 'Num_of_cycles',
            title: 'Num of cycles',
            enabled: false
        },
        {
            key: 'Scenario_description',
            title: 'Scenario Description',
            enabled: false
        },
        {
            key: 'Expected_start_date',
            title: 'Expected start date',
            enabled: false
        },
        {
            key: 'Expected_end_date',
            title: 'Expected end date',
            enabled: false
        },
        
        // {
        //     key: 'Num_of_scenarios',
        //     title: 'Num of scenarios',
        //     enabled: false
        // },
    ];

    constructor(private http: HttpClientService, private simulationService: NewSimulationService) {
    }

    public fetchSavedSimulations(): Promise<any> {

        const that = this;

        const promise = new Promise((resolve, reject) => {

            if (that.regions.length === 0) {
                that.simulationService.fetchRegions()
                    .subscribe((regions) => {

                        const obs = [];

                        for (const region of regions) {
                            obs.push(that.simulationService.fetchCountriesByRegion(region['Country_Region_1']));
                        }

                        Observable.forkJoin(obs)
                            .subscribe((regionResults) => {

                                for (let i = 0; i < regionResults.length; i++) {
                                    regions[i]['countries'] = regionResults[i];
                                }
                                that.regions = regions;

                                that.http.post('/showsavedscenarios', null)
                                    .subscribe((response) => {
                                        let scenarios = that.prepareStartEndDate(response);
                                        resolve(that.fillRegions((scenarios)));
                                    });

                            }, (error3) => {
                                console.log(error3);
                            });

                    }, (error2) => {
                        console.log(error2);
                    });
            } else {
                that.http.post('/showsavedscenarios', null)
                    .subscribe((scenarios) => {
                        resolve(that.fillRegions((scenarios)));
                    });
            }
        });

        return promise;
    }

    private prepareStartEndDate(scenarios: any): Array<any> {

        for (let scenario of scenarios) {
            const startDate = new Date(scenario['Expected_start_date']);
            const endDate = new Date(scenario['Expected_end_date']);

            scenario['startEndDate'] = {
                beginDate: {
                    year: startDate.getFullYear(),
                    month: startDate.getMonth(),
                    day: startDate.getDate()
                },
                endDate: {
                    year: endDate.getFullYear(),
                    month: endDate.getMonth(),
                    day: endDate.getDate()
                }
            };
        }

        return scenarios;
    }

    private fillRegions(scenarios: any): Array<any> {

        for (const scenario of scenarios) {
            scenario['region'] = this.regions.find((region) => {
                return region.countries.find((country) => country['Country_name'] === scenario['Country_name']);
            })['Country_Region_1'];
        }

        return scenarios;
    }

    public fetchSimulation(data): Promise<any> {

        const that = this;

        const promise = new Promise((resolve, reject) => {
            this.http.post('loadscenario', data).subscribe(
                (result) => {

                    that.loadedSimulation = result;

                    that.prepareChartData(that.loadedSimulation, data);

                    resolve(that.loadedSimulation);
                }, (error) => {
                    reject(error);
                }
            );
        });
        return promise;
    }

    public prepareChartData(result: any, data: any) {
        const firstChartData = [];
        firstChartData.push({
                title: 'Total Gross Revenue',
                value: Number.parseFloat(result['TOTGR']),
                color: '150, 162, 166',
                postfix: data.Currency
            },
            {
                title: 'Total Net Revenue',
                value: Number.parseFloat(result['TOTNR']),
                color: '150, 162, 166',
                postfix: data.Currency
            }
        );

        const secondCharData = [];
        for (let i = 0; i < result['GRCYC'].length; i++) {

            const grcyc = Number.parseFloat(result['GRCYC'][i]);
            const nrcyc = Number.parseFloat(result['NRCYC'][i]);

            secondCharData.push({
                name: 'Period ' + (i + 1),
                total: grcyc > nrcyc ? grcyc : nrcyc,
                postfix: data.Currency,
                series: [
                    {
                        name: 'Gross Revenue per MEA period',
                        value: grcyc
                    },
                    {
                        name: 'Net Revenue per MEA period',
                        value: nrcyc
                    }
                ]
            });
        }

        const thirdChardData = [];
        for (let i = 0; i < result['EXFNETPCYC'].length; i++) {

            const exfnetpcyc = Number.parseFloat(result['EXFNETPCYC'][i]);
            const exflistp = Number.parseFloat(result['EXFLISTP'][i]);

            thirdChardData.push({
                name: 'Period ' + (i + 1),
                total: exfnetpcyc > exflistp? exfnetpcyc : exflistp,
                postfix: data.Currency,
                series: [
                    {
                        name: 'List Price per MEA period',
                        value: exflistp
                    },
                    {
                        name: 'Net ExF Price per MEA period',
                        value: exfnetpcyc
                    }
                ]

            })
        }

        const fourthChartData = {
            name: "Total discount",
            value: Number.parseFloat(result['DSC'])
        };

        this.loadedSimulation.firstChartData = firstChartData;
        this.loadedSimulation.secondCharData = secondCharData;
        this.loadedSimulation.thirdChartData = thirdChardData;
        this.loadedSimulation.fourthChartData = fourthChartData;

    }

}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/simulation-list/simulations.service.ts